import React, {useState, useEffect} from 'react';

import KindergartensList from '../../../kindergartens/list/components/KindergartensPage/KindergartensPage';
import { findKgsWithInternationalAgreement } from '../activity';


const benefits_fixed = [
  "5bfb996f0b7fb2059b8828c9",
  "5c16b5a22f8be751f04fce92",
  "60e81561904ae40729056dc4"
]

const Step5 = ({ formData, onChange }) => {

  const [isFixed, setIsFixed] = useState(false);

  const [hebrewKgList, setHebrewKgList] = useState([]);
  const [hebrewKgLoading, setHebrewKgLoading] = useState(false);
  const [hebrewKgLoaded, setHebrewKgLoaded] = useState(false);

  const isHebrewProgram = formData.preferences?.languageTraining === 'ir';

  useEffect(()=>{

    setIsFixed(benefits_fixed.includes(formData.benefits.type));

  },[formData.benefits.type])

  // Завантажуємо перелік садочків з групами за міжнародною угодою —
  // потрібен і для фільтрації списку, і для перевірки конфлікту з пільгою
  useEffect(() => {
    if(!isHebrewProgram) return;
    if(hebrewKgLoaded) return;

    let cancelled = false;
    setHebrewKgLoading(true);

    findKgsWithInternationalAgreement()
      .then(list => { if(!cancelled) { setHebrewKgList(list); setHebrewKgLoaded(true); } })
      .catch(() => { if(!cancelled) { setHebrewKgList([]); setHebrewKgLoaded(true); } })
      .finally(() => { if(!cancelled) setHebrewKgLoading(false); });

    return () => { cancelled = true; };
  }, [isHebrewProgram]);

  // Якщо обрано навчання за міжнародною угодою і НЕМАЄ фіксованої пільги —
  // раніше обрані садочки могли не мати таких груп, тож обнуляємо список
  useEffect(() => {
    if(isHebrewProgram && !isFixed && formData.selectedSchools.length > 0){
      onChange('selectedSchools', []);
    }
  }, [isHebrewProgram, isFixed]);

  const fixedKgId = formData.benefits.kindergarten;

  // Конфлікт: пільга прив'язує до конкретного садочку, але в ньому немає
  // групи за міжнародною угодою
  const isConflict = isHebrewProgram && isFixed && hebrewKgLoaded &&
    !!fixedKgId && !hebrewKgList.some(kg => kg._id === fixedKgId);

  const handleSchoolSelect = (kgId) => {
    const newArr = formData.selectedSchools.includes(kgId) ? formData.selectedSchools.filter(l=>l!==kgId) : [...formData.selectedSchools, kgId] ;
    onChange('selectedSchools', newArr );
  };

  const getTitle = () => {
    if (isFixed) return 'Обрана пільна призначена тільки для одного садочку';
    if (isHebrewProgram) return 'Обрання садочку (показані лише садочки з групами за міжнародною угодою)';
    return 'Обрання садочку';
  };

  return (
    <div className="form-section form-section--wide">
      <h2 className="form-section-title">{getTitle()}</h2>

      {isConflict ? (
        <div className="alert alert-danger">
          Вибір садочку неможливий у зв'язку з протиріччям встановленої пільги: обраний
          за пільгою садочок не має групи за міжнародною угодою (додаткове вивчення мови
          івриту). Змініть пільгу на попередньому кроці або зніміть позначку про навчання
          за міжнародною угодою на кроці «Додаткові побажання».
        </div>
      ) : (
        <>
          {isHebrewProgram && hebrewKgLoading && (
            <div className="alert alert-info">Перевірка переліку садочків...</div>
          )}
          <KindergartensList 
            isListView={true} 
            isChecked={true} 
            listChecked={formData.selectedSchools} 
            onCheck={handleSchoolSelect} 
            isFixed={isFixed} 
            uncheckAll={()=>onChange('selectedSchools', [])}
            intlAgreementOnly={isHebrewProgram}
          />
        </>
      )}
    </div>
  );
};

export default Step5;